




























import tokenProvider from "axios-token-interceptor";
import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import i18n from "@/Plugin/i18n";
import BaseVue from "@/core/BaseVue";
import LanguageService from "./services/language.service";
import RoleRequest from "./components/roleRequest/roleRequest.vue";

import CountryService from "@/services/country.service";
import myMSALObj from "./config/azure-b2c/settings";
import User from "./models/security/user.model";
import UserBasicInformation from "./models/security/user-basic-information.model";
import UserService from "./services/user.service";
import { AuthResponse } from "msal";

@Component({
  components: { RoleRequest },
})
export default class App extends Vue {
  $authService: any;
  requestObj = {
    redirectUri: process.env.VUE_APP_BASE_URL,
    scopes: [
       "https://mescytportal.onmicrosoft.com/fondocyt-portal/user_impersonation",
       "https://mescytportal.onmicrosoft.com/fondocyt-portal/openid",
       "https://mescytportal.onmicrosoft.com/fondocyt-portal/offline_access"
      //"https://whitecape.onmicrosoft.com/whitecape/user_impersonation",
      //"https://whitecape.onmicrosoft.com/whitecape/openid",
      //"https://whitecape.onmicrosoft.com/whitecape/offline_access",
    ],
  };
  loading = true;
  cookies = localStorage.getItem("cookies")
    ? localStorage.getItem("cookies") == "true"
    : true;
  searchingCookies = true;

  get frontendBaseUrl() {
    if (process.env.NODE_ENV === "development") {
      return window.location.origin;
    }
    return (process.env.VUE_APP_BASE_URL || window.location.origin).replace(/\/+$/, "");
  }

  get cookiesCheckUrl() {
    return `${this.frontendBaseUrl}/cookies-2.html`;
  }

  get isLoggedIn() {
    return this.$store.getters.isLoggedIn;
  }
  get user() {
    return this.$store.state.user;
  }

  created() {
    this.setup();
    this.registerHttpInterceptor();
    this.alertErrorDisabledUser();
    this.setLanguages();
    //this.getUser(this);
  }
  mounted() {}

  setup() {
    this.$forceUpdate();
    this.$store.commit("set_loading", false);
    let checkResolved = false;

    const finishCookieCheck = (supported: boolean) => {
      if (checkResolved) {
        return;
      }

      checkResolved = true;
      this.searchingCookies = false;

      if (!supported) {
        localStorage.setItem("cookies", "false");
        this.cookies = false;
      } else {
        this.cookies = true;
        localStorage.setItem("cookies", "true");
      }

      this.$forceUpdate();
      var loadingDiv = document.getElementById("loadingDiv");
      if (loadingDiv) {
        loadingDiv.remove();
      }
    };

    var receiveMessage = (evt) => {
      if (evt.data === "MM:3PCunsupported") {
        finishCookieCheck(false);
      } else if (evt.data === "MM:3PCsupported") {
        finishCookieCheck(true);
      }
    };
    window.addEventListener("message", receiveMessage, false);

    // Prevent infinite loading if the iframe is blocked, missing, or cross-site messaging fails.
    window.setTimeout(() => {
      finishCookieCheck(true);
    }, 5000);
  }

  @Watch("$route", { immediate: true, deep: true })
  onUrlChange(newVal) {
    // this.getUser(this);
  }

  setLanguages() {
    var locale = "do";
    var currentLocale = localStorage.getItem("currentLocale");
    if (currentLocale) {
      locale = currentLocale;
    }
    var languageService = new LanguageService();

    languageService.getJSON().then((msg) => {
      localStorage.setItem("locales", JSON.stringify(msg));
      i18n.setLocaleMessage(locale, msg[locale]);
    });
  }
  registerHttpInterceptor() {
    var self = this as any;

    self.$http.interceptors.request.use(
      async (request: any) => {
        var token = localStorage.getItem("token");
        if (token) {
          request.headers.common["Authorization"] = `Bearer ${token}`;
        } else {
          await setToken(request);
        }
        return request;
      },
      async (error: any) => {
        return Promise.reject(error);
      }
    );

    self.$http.interceptors.response.use(undefined, async (error) => {
      const originalRequest = error.config;
      if (error.response && error.response.status === 401) {
        if (!originalRequest._retry) {
          originalRequest._retry = true;
          await setToken(self.$http.defaults, originalRequest);
          return self.$http(originalRequest);
        }
      }
      return Promise.reject(error);
    });
    const setToken = async (request: any, originalRequest = null) => {
      const res = (await this.getToken()) as AuthResponse;
      if (res && res.accessToken) {
        request.headers.common["Authorization"] = `Bearer ${res.accessToken}`; // This fails if MSAL requested a new token

        if (originalRequest) {
          originalRequest.headers.Authorization =
            request.headers.common["Authorization"];
        }

        localStorage.setItem("token", res.accessToken);
      } else {
        var token = localStorage.getItem("token");
        request.headers.common["Authorization"] = `Bearer ${token}`;
        if (originalRequest) {
          originalRequest.headers.Authorization =
            request.headers.common["Authorization"];
        }
      }
    };
  }

  async getToken(secondChance: boolean = false): Promise<any> {
    var self = this;
    return await new Promise(async (resolve, reject) => {
      if (this.cookies) {
        await myMSALObj
          .acquireTokenSilent(self.requestObj)
          .then(function (loginResponse) {
            if (!loginResponse.accessToken) {
              loginResponse.accessToken = localStorage.getItem("token");
            } else {
              localStorage.setItem("tokenObj", JSON.stringify(loginResponse));
              localStorage.setItem("token", loginResponse.accessToken);
              self.$store.commit("set_token", loginResponse.accessToken);
            }
            if (
              !self.user.id &&
              !localStorage.getItem("TheUserIsAlreadysended")
            ) {
              var account = myMSALObj.getAccount();
              var user = {} as any;
              user.adid = account.accountIdentifier;
              user.name = account.idToken.given_name;
              user.lastName = account.idToken.family_name;
              user.email = account.idToken.emails[0];
              self.$store.commit("set_loading", true);

              localStorage.setItem("TheUserIsAlreadysended", "1");

              var userService = new UserService();
              userService
                .createIfNoExist(user)
                .then((x) => {
                  localStorage.setItem("user", JSON.stringify(x));
                  self.$store.commit("set_user", x);
                  self.$store.commit("set_loading", false);
                })
                .finally(() => {
                  localStorage.removeItem("TheUserIsAlreadysended");
                });
            }

            return resolve(loginResponse);
          })
          .catch(async (error) => {
            if (this.cookies) {
              if (!secondChance) {
                var token = await myMSALObj.acquireTokenRedirect(
                  self.requestObj
                );
                
                return resolve(myMSALObj);
              } else {
                alert(error);
                localStorage.clear();
                let newError = new Error(error);
                console.log(error);
                myMSALObj.logout();
                return reject(newError);
              }
            }
          });
      }
    });
  }

  doLogOut() {
    localStorage.removeItem("id_token_obj");
    localStorage.removeItem("user");
    localStorage.removeItem("cookies");
    this.$authService.logout();
  }

  alertErrorDisabledUser() {
    if (this.user.disabled) {
      this.$buefy.dialog.alert({
        title: "Error",
        message: "message.thisUserIsDisabled",
        type: "is-danger",
        hasIcon: true,
        icon: "times-circle",
        iconPack: "fa",
        ariaRole: "alertdialog",
        ariaModal: true,
        onConfirm: () => this.doLogOut(),
      });
    }
  }
}
